import { render, staticRenderFns } from "./notifications-data.vue?vue&type=template&id=1f7bc089"
import script from "./notifications-data.vue?vue&type=script&lang=js"
export * from "./notifications-data.vue?vue&type=script&lang=js"
import style0 from "./notifications-data.vue?vue&type=style&index=0&id=1f7bc089&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports